<template>
    <page :busy="busy">
        <div id="1">
            <div v-if="componentLoaded && !isNil(deviceToken) && !isNil(chatUserId) && !isNil(userPermissions)">
                <inbox-component
                    :subscriber-id="userSubscriberId"
                    :chat-user-id="chatUserId"
                    :device-token="deviceToken"
                    :websocket-url="websocketUrl"
                    :header-height="calcHeaderHeight()"
                    :permissions="permissions"
                    @toast="toastHandler"
                    :toast-event="toastEvent"
                    :currency-symbol="userCurrencySymbol"
                    :css-version="cssVersion"
                    :cjs-version="cjsVersion"
                    id="inbox"
                />
            </div>
        </div>
    </page>
</template>

<script>
    import isNil from 'lodash/isNil';
    import { mapGetters } from 'vuex';
    import API from '../../api';
    import Page from '../generic/page/page.vue';
    import { CHAT_METADATA_ENDPOINT } from '../../endpoints';

    export default {
        name: 'ChatHomePage',
        components: {
            Page,
        },
        computed: {
            ...mapGetters('header', [
                'userCurrencySymbol',
                'userPermissions',
                'userSubscriberId',
                'userWebsocketToken',
            ]),
            websocketUrl() {
                return window.WEBSOCKET_URL;
            },
            permissions() {
                return JSON.stringify(this.userPermissions);
            },
            cssVersion() {
                return window.UNIFIED_INBOX_CSS_VERSION;
            },
            cjsVersion() {
                return window.UNIFIED_INBOX_CJS_VERSION;
            },
        },
        data() {
            return {
                busy: false,
                componentLoaded: false,
                chatUserId: null,
                deviceToken: null,
                toastEvent: null,
            };
        },
        async mounted() {
            (async () => {
                this.busy = true;
                try {
                    await this.loadInboxComponent();
                    await this.fetchMetadata();
                } finally {
                    this.busy = false;
                }
            })();
        },
        methods: {
            isNil,
            async fetchMetadata() {
                try {
                    const response = await API.get(CHAT_METADATA_ENDPOINT());
                    this.chatUserId = response.data.chat_user_id;
                } catch (err) {
                    this.errorToast({ text: 'Could not load meta data.' });
                }
            },
            loadInboxComponent() {
                if (window.UNIFIED_INBOX_USE_DEV_SERVER) {
                    let link = document.createElement('link');
                    link.rel = 'stylesheet';
                    link.href = 'http://localhost:5173/src/styles/main.css';
                    document.head.appendChild(link);

                    link = document.createElement('link');
                    link.rel = 'stylesheet';
                    link.href = '/static/chat/assets/fonts/lato/lato.css';
                    document.head.appendChild(link);

                    const script = document.createElement('script');
                    script.type = 'module';
                    script.src = 'http://localhost:5173/src/main.ce.ts';
                    script.onload = () => {
                        this.componentLoaded = true;
                    };
                    document.body.appendChild(script);
                } else {
                    let link = document.createElement('link');
                    link.rel = 'stylesheet';
                    link.href = `/static/chat/style.${window.UNIFIED_INBOX_CSS_VERSION}.css`;
                    document.head.appendChild(link);

                    link = document.createElement('link');
                    link.rel = 'stylesheet';
                    link.href = '/static/chat/assets/fonts/lato/lato.css';
                    document.head.appendChild(link);

                    const script = document.createElement('script');
                    script.src = `/static/chat/inbox-component.${window.UNIFIED_INBOX_CJS_VERSION}.cjs`;
                    script.onload = () => {
                        this.componentLoaded = true;
                    };
                    document.body.appendChild(script);
                }
            },
            toastHandler(data) {
                const mode = data.detail[0].mode;
                if (mode === 'info-action') {
                    this.infoActionToast({
                        text: data.detail[0].message,
                        callback: () => {
                            this.toastEvent = data.detail[0].conversationId;
                        },
                    });
                } else if (mode === 'info') {
                    this.infoToast({ text: data.detail[0].message });
                } else if (mode === 'success') {
                    this.successToast({ text: data.detail[0].message });
                } else if (mode === 'error') {
                    this.errorToast({ text: data.detail[0].message });
                } else if (mode === 'warning') {
                    this.warningToast({ text: data.detail[0].message });
                }
            },
            calcHeaderHeight() {
                var element = document.getElementById('1');
                var rect = element?.getBoundingClientRect();
                const offset = rect?.top || 0;
                return offset;
            },
        },
        watch: {
            userWebsocketToken(newVal, oldVal) {
                this.deviceToken = this.userWebsocketToken;
            },
        },
    };
</script>

<style scoped lang="scss"></style>
